import { marketingConsentTextResponseSchema } from '@/api/marketingConsent/schemas';
import type { MarketingConsentPayload } from '@/api/marketingConsent/types';
import { apiRequest } from '@/api/utils/api';

export const getMarketingConsentText = () =>
  apiRequest({
    url: '/marketing-consent/text',
    method: 'GET',
    schema: marketingConsentTextResponseSchema,
  });

export const setMarketingConsent = (payload: MarketingConsentPayload) =>
  apiRequest<undefined>({ url: '/marketing-consent', method: 'POST', data: payload });
